import {ChangeDetectionStrategy, Component, Input} from '@angular/core'

@Component({
  selector: 'bgo-hero-partnership',
  templateUrl: './hero-partnership.component.html',
  styleUrls: ['hero-partnership.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroPartnershipComponent {
  @Input() title!: string
}
